<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/logo.svg')"
    title="Favicon"
    @initializeData="initializeData"
  >
    <template #main>
      <ImageUploadButton
        label="Upload a transparent PNG max 32x32px. Favicons are usually the same as the icon logos. The asset must be a square to work."
        :image="faviconUrl"
        :acceptedTypes="['.png', '.jpg', '.jpeg', '.ico', '.webp']"
        :s3BucketPath="s3BucketPath"
        :filestackIntent="filestackIntent"
        @changeImageUrl="handleImageUrlChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ImageUploadButton from '../components/ImageUploadButton.vue';

import {
  resolveLookAndFeelFilestackIntent,
  resolveLookAndFeelResourcesPath
} from '@/studio/lookAndFeel/filestackIntent';

export default {
  name: 'Favicon',
  components: {
    ModuleWrapper,
    ImageUploadButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      s3BucketPath: resolveLookAndFeelResourcesPath(this.$route),
      faviconUrl: null
    };
  },
  mounted() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      changesMade: 'getChangesMade',
      getInitialModuleData: 'getInitialModuleData'
    }),
    filestackIntent() {
      return resolveLookAndFeelFilestackIntent(this.$route, 'image');
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    initializeData() {
      const moduleKeys = ['favicon'];
      const moduleData = this.getInitialModuleData(moduleKeys);
      this.faviconUrl = moduleData.favicon;
    },
    handleImageUrlChange(url) {
      this.faviconUrl = url;
      this.setChangesMadeInEvent({
        favicon: url || null
      });
    }
  }
};
</script>
